import { randomize } from '@/data/constants';
import customCheckerboard from "@/mixins/CustomCheckerboard";
import patternMaker from "@/mixins/PatternMaker";


export default {
  mixins: [ customCheckerboard, patternMaker],
  computed: {
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    defaultRecipe() {
      return this.$store.state.recipe.defaultRecipe;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    activeComponent() {
      return this.$store.state.legacyNavigation.activeComponent;
    },
    previousSwatch() {
      return this.$store.state.undo.previousSwatch;
    },
    previousRecipe() {
      return this.$store.state.undo.previousRecipe;
    },
    personalizationComponentName() {
      return this.$store.getters["personalization/getPersonalizationComponentName"];
    },
    isApparelEnabled() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    hasUndoBeenApplied() {
      return this.$store.state.undo.hasUndoBeenApplied;
    },
    components() {
      return this.$store.state.undo.components;
    },
  },
  methods: {
    getPreviousSwatchToSave(component, feature, currentSwatch, geometryComponent) {
        if(currentSwatch) {
          return {
            component,
            swatch: currentSwatch,
            swatchId: currentSwatch.id,
            feature: feature,
          };
        }

        const { swatch_id } = this.recipe_v2?.components?.[geometryComponent ? geometryComponent : component];
        const swatchObj = this.$store.getters['swatches/returnSwatchObj']({ swatchId : swatch_id });
        const imgLibData = feature === "imageLibrary" ? this.$store.state.imageGallery.storageController.recipe?.components?.[component] : null;

        return {
          component,
          swatch: swatchObj || null,
          swatchId: swatch_id,
          feature: feature || swatchObj?.id,
          imgLibData,
        };
    },

    saveLastSwatchApplied(newPreviousSwatch) {
      let payload = {};

      newPreviousSwatch.forEach((previousData) => {
        if (!previousData.feature) {
          payload = { ...payload, [previousData.component]: previousData };
        }
      });

      this.$store.commit("undo/UPDATE_LAST_SWATCH_APPLIED", payload);
    },

    savePreviousEmbroidery(personalizationData, component) {
      const swatch = personalizationData ? [...personalizationData] : [...this.previousSwatch.swatch];
      this.$store.commit('undo/CLEAN_RECIPE');
      this.$store.commit("undo/UPDATE_PREVIOUS_SWATCH", [{ component, swatch, feature : 'embroidery'  }]);
    },

    cleanPreviousEmbroidery(personalizationData) {
      const swatch = personalizationData;
      this.$store.commit('undo/CLEAN_RECIPE');
      this.$store.commit("undo/UPDATE_PREVIOUS_SWATCH", [{ component : this.activeComponent, swatch, feature : 'embroidery'  }]);
    },

    /***
     * Save the previous swatch and component selected into the undo store
     */
    savePreviousSwatch({ feature, saveComponents, currentSwatch, geometryComponent }) {
      const payload = [];
      // TODO fix apparel to work with this
      if (!this.configuration?.undo?.models_enabled?.includes(this.pdm.sku)) return;
      if (!saveComponents) {
        payload.push(this.getPreviousSwatchToSave(this.activeComponent, feature, currentSwatch, geometryComponent));
      } else {
        const { lastSwatchApplied } = this.$store.state.undo;

        saveComponents.forEach((saveCopmonent) => {
          const { component, feature } = saveCopmonent;

          if (saveCopmonent.isSameFeature && feature && Object.keys(lastSwatchApplied).length > 0) {
            const lastSwatchComponent = lastSwatchApplied[component];

            if (lastSwatchComponent) {
              payload.push(lastSwatchComponent);
            }
          } else {
            payload.push(this.getPreviousSwatchToSave(component, feature));
          }
        });
      }

      this.$store.commit("undo/CLEAN_RECIPE");
      this.$store.commit("undo/UPDATE_PREVIOUS_SWATCH", payload);
      /***
       * check if the flag is true so it only calls the mutations once
       * check if the component is already in the set (for multiple components cases)
       * check if is precreated recipe
      */
      if(!this.hasUndoBeenApplied && !this.components?.has(payload) && this.components.size > 1 && this.$store.state.utils.queryParams?.recipe) {
        this.$store.commit("undo/CLEAN_UNDO");
        this.$store.commit("undo/COMPONENTS", payload);
        // for authentic only change that flag if  this.componets has more than one ugc component
        if(this.pdm.sku === 'authentic-classic') {
          this.$store.commit("undo/HAS_UNDO_BEEN_APPLIED", true);
        }
      }
      this.saveLastSwatchApplied(payload);
    },
    /***
     * Restore the previous swatch and clean the undo store
     */
    async undo() {
      if(!!Object.keys(this.previousRecipe).length) {
        new Promise((resolve, reject) => {
          const isRandomizeFeature = this.$store.state.undo.feature === randomize;

          if (isRandomizeFeature) {
            this.resetUpgradeOptions();
          }

          this.$store.commit('recipe/SET_RECIPE_V2', this.previousRecipe);
          this.$store.commit('ugc/tempData/SET_RECIPE', this.previousRecipe);
          this.setSwatchesSelectedFromRecipe(this.previousRecipe);

          if (isRandomizeFeature) {
            this.applyExclusivitybyDefaultComponent(true);
          }

          this.$eventBus.$emit('apply-recipe', {recipe: this.previousRecipe, resolve, reject, applyingRecipe: true});
        }).then(() => {
          this.$store.commit('utils/SET_IS_FINISH_MY_DESIGN_APPLIED', false);
        });
      } else {
        const prevSwatches = this.previousSwatch;
        for (const previousData of this.previousSwatch) {
          const { feature } = previousData;
          if (feature === 'customCheckerboard') {
            await this.undoCheckerboard(previousData);
          } else if (feature === 'patternMaker') {
            await this.undoPatternMaker(previousData);
          } else if (feature === 'embroidery') {
            this.undoEmbroidery();
          } else if (feature === 'ugc') {
            await this.undoUGC(previousData);
          } else if (feature === 'imageLibrary') {
            await this.undoImageLibrary(previousData);
          } else {
            this.undoSwatch(previousData);
          }
        }
        this.$eventBus.$emit("blockRelationSwatches");
        this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', prevSwatches[0].component);
      }
      this.$store.commit('undo/CLEAN_UNDO');
      this.$store.dispatch("buyPanel/GET_PRICE", { recipe: this.$store.state.recipe.recipe_v2});
    },
    undoCheckerboard(previousData) {
      const { component } = previousData;

      this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', component);
      this.updateCheckerboardRecipe(component);

      return this.applyCheckerboardTo3D(component);
    },
    undoPatternMaker(previousData) {
      const { component } = previousData;

      this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', component);

      return this.applyPatternMakerTo3D(component);
    },
    undoUGC(previousData) {
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "ugc");
      const { component } = previousData;
      this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', component);
      this.reApplyUgcSwatch({componentNameParam: component});
      return this.resetGeometrybyUGCFeature();
    },
    undoImageLibrary(previousData) {
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
      const { component, imgLibData } = previousData;
      this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', component);
      this.$eventBus.$emit("reApplyImageLibrary", {imgLibData});
      return this.resetGeometrybyUGCFeature();
    },
    undoEmbroidery(){
      const isPersonalized = this.$store.getters["personalization/isPersonalizationInComponentRecipe"]();
      const componentName = this.personalizationComponentName;
      const messages = this.previousSwatch[0].swatch;
      const components = this.recipe_v2.components;
      const color = {
        name: messages[0]?.color || 'black',
        hex: messages[0]?.hex || '#000000'
      };

      if(isPersonalized){
        const personalization = components[componentName].personalization;
        if(personalization && personalization.length > 0
          && messages && messages.length > 0
          && personalization[0].text !== messages[0].text){
          messages.forEach( (message, index) => {
            this.$store.commit("personalization/SAVE_DATA", {
              text: message.text.toUpperCase(),
              index
            });
          });

          this.$store.commit("personalization/CHANGE_COLOR", color);
          this.$store.commit(
            "personalization/ADD_PERSONALIZATION_COMPONENT",
            componentName
          );
          this.$store.commit("personalization/SAVE_USER_DATA");
          this.$personalization.applyPersonalizationRecipe({componentName});
        } else {
          this.$personalization.removePersonalization();
        }
      } else {
        messages.forEach( (message, index) => {
          this.$store.commit("personalization/SAVE_DATA", {
            text: message.text.toUpperCase(),
            index
          });
        });

        this.$store.commit("personalization/CHANGE_COLOR", color);
        this.$store.commit(
          "personalization/ADD_PERSONALIZATION_COMPONENT",
          componentName
        );
        this.$store.commit("personalization/SAVE_USER_DATA");
        this.$personalization.applyPersonalizationRecipe({componentName});
        this.savePreviousEmbroidery(messages, componentName);
      }
    },

    undoSwatch(previousData) {
      this.selectSwatch(previousData.swatch, { component: previousData.component, applyUndo: true });
    },
  },
  created () {
    this.$eventBus.$on("savePreviousSwatch", this.savePreviousSwatch);
  },
  beforeDestroy () {
    this.$eventBus.$off("savePreviousSwatch", this.savePreviousSwatch);
  },
};
